import React from 'react';
import { ContentSectionProps } from '../../types/pipeline.types';
import './ContentSection.styles.css';

export const ContentSection: React.FC<ContentSectionProps> = ({
  variant = 'transparent',
  spacing = 'medium',
  children
}) => {
  return (
    <div className={`content-section content-section--${variant} content-section--spacing-${spacing}`}>
      {children}
    </div>
  );
};